import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import { SpeakerNotes } from 'material-ui-icons'
import Menu, { MenuItem } from 'material-ui/Menu';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment'

import * as userdetails from '../../../actions/userdetails';
import AuditInfo from './auditinfo';





class DataTableHead extends React.Component {
    static propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, numSelected, rowCount, loggedinUserRole_id, audittype } = this.props;  
        // console.log("audittype==>" + audittype)      
        var columnData;
        if( audittype == 'user'){
            columnData = [
                { id: 'username', numeric: false, disablePadding: false, label: 'User Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];

        } else if(audittype == 'meeting'){         
            columnData = [
                { id: 'meetingName', numeric: false, disablePadding: false, label: 'Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }
        else if(audittype == 'agenda'){         
            columnData = [
                { id: 'name', numeric: false, disablePadding: false, label: 'Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }
        else if(audittype == 'folder'){         
            columnData = [
                { id: 'title', numeric: false, disablePadding: false, label: 'Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }
        else if(audittype == 'resolutions'){         
            columnData = [
                { id: 'name', numeric: false, disablePadding: false, label: 'Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }
        else if(audittype == 'decisions'){         
            columnData = [
                { id: 'subject', numeric: false, disablePadding: false, label: 'title', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }
        else if(audittype == 'AgendaFile'){         
            columnData = [
                { id: 'name', numeric: false, disablePadding: false, label: 'Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }
        else if(audittype == 'folderFile'){         
            columnData = [
                { id: 'name', numeric: false, disablePadding: false, label: 'Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                //{ id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }
        else if(audittype == 'resolutionFile'){         
            columnData = [
                { id: 'name', numeric: false, disablePadding: false, label: 'Name', isAdminOnly: false },
                { id: 'rev_type', numeric: false, disablePadding: true, label: 'Action', isAdminOnly: false },
                { id: 'revdate', numeric: false, disablePadding: true, label: 'Date', isAdminOnly: false },
                { id: 'ipaddress', numeric: false, disablePadding: true, label: 'Ip Address', isAdminOnly: false },
                { id: 'createdBy', numeric: false, disablePadding: true, label: 'Created By', isAdminOnly: true },
                // { id: '', numeric: false, disablePadding: true, label: 'Before', isAdminOnly: true },  
                { id: '', numeric: false, disablePadding: true, label: 'Detail' },
            ];
        }




        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            (column.isAdminOnly && loggedinUserRole_id != "2") ? null :
                                <TableCell
                                    key={column.id}
                                    numeric={column.numeric}
                                    padding={column.disablePadding ? 'none' : 'checkbox'}
                                >
                                    <Tooltip
                                        title="Sort"
                                        placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={order}
                                            onClick={this.createSortHandler(column.id)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

class DataTable extends React.Component {
    handleRequestSort = (event, property) => {
        // console.log('sort property',property)
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        // console.log('this.state.data',this.state.data)

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    onOptionMenuSelect = (data, event) => {
        this.state.user = data;
        this.setState({ user: data, menuState: true, anchorEl: event.currentTarget });
    };
  
    closeDialog = (data) => {
        this.setState({ openDialog: false });
    }

    getAuditInfo= (data) => {
        // console.log(data);
       this.setState({auditInfo:data,  openDialog:true });
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            anchorEl: undefined,
            menuState: false,
            openDialog: false,
            order: 'asc',
            orderBy: 'calories',
            data: [],
            page: 0,
            rowsPerPage: 20,
            user: null,
            auditInfo:null,
        };
    }



    render() {
        const { menuState, anchorEl, data, order, orderBy, selected, rowsPerPage, page } = this.state;
        this.state.data = this.props.data;
        this.state.audittype = this.props.audittype;     
       
       var columnData;
    //    if( this.props.audittype == 'user'){            
    //        columnData = [{ value: 'username' },{ value: 'rev_type' }, { value: 'revDate' },{ value: 'ipaddress' },{ value: 'createdBy' }, { value: 'before' },{ value: 'after'}];
    //     } else if(this.props.audittype == 'meeting'){         
    //         columnData = [{ value: 'meetingName'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     } else if(this.props.audittype == 'agenda'){         
    //         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     } else if(this.props.audittype == 'folder'){         
    //         columnData = [{ value: 'title'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     }  else if(this.props.audittype == 'resolutions'){         
    //         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     }  else if(this.props.audittype == 'decisions'){
    //         columnData = [{ value: 'subject'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     }  else if(this.props.audittype == 'AgendaFile'){
    //         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     }  else if(this.props.audittype == 'folderFile'){
    //         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     }  else if(this.props.audittype == 'resolutionFile'){
    //         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'},{ value: 'before'}, { value: 'after'}];
    //     }     


    if( this.props.audittype == 'user'){            
        columnData = [{ value: 'username' },{ value: 'rev_type' }, { value: 'revDate' },{ value: 'ipaddress' },{ value: 'createdBy' },{ value: 'after'}];
     } else if(this.props.audittype == 'meeting'){         
         columnData = [{ value: 'meetingName'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     } else if(this.props.audittype == 'agenda'){         
         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     } else if(this.props.audittype == 'folder'){         
         columnData = [{ value: 'title'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     }  else if(this.props.audittype == 'resolutions'){         
         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     }  else if(this.props.audittype == 'decisions'){
         columnData = [{ value: 'subject'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     }  else if(this.props.audittype == 'AgendaFile'){
         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     }  else if(this.props.audittype == 'folderFile'){
         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     }  else if(this.props.audittype == 'resolutionFile'){
         columnData = [{ value: 'name'},{ value: 'rev_type' },{ value: 'revDate'},{ value: 'ipaddress' },{ value: 'createdBy'}, { value: 'after'}];
     }     

        
        return (
            <Paper>
                <div className="flex-auto">
                    <div className="table-responsive-material">
                        <Table className="">
                            <DataTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={this.state.data ? this.state.data.length : 0}
                                loggedinUserRole_id={this.props.loggedinUserRole_id}
                                audittype = {this.state.audittype}
                            />         
                            <TableBody>
                                {/* {console.log('data', this.state.data)} */}
                                { !this.state.data ?
                                    <TableRow>
                                        <TableCell colSpan={6}/>
                                    </TableRow>
                                    :
                                    this.state.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, index) => {
                                        var i = 0;
                                        if(index!=0){
                                            i = index -1;
                                        }                                         
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={index}
                                            >       
                                            {columnData.map(column => {                                            
                                                return (
                                                  (column.value=="revDate")?<TableCell padding="none">{moment(n[column.value]).format("DD/MM/YYYY hh:mm A")}</TableCell>
                                                  :((column.value=="before")? <TableCell padding="none"><a><button onClick={this.getAuditInfo.bind(this,this.state.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)[i])}>Prev</button></a></TableCell>
                                                  :((column.value=="after")?<TableCell padding="none"><a><button onClick={this.getAuditInfo.bind(this,n)}>Info</button></a></TableCell>
                                                  :<TableCell padding="none">{n[column.value]}</TableCell>)))
                                            }) }                                                                                           
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={this.state.data ? this.state.data.length : 0}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        rowsPerPageOptions={[20, 40, 100]}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>  
                        <AuditInfo open={this.state.openDialog} data={this.state.auditInfo} audittype={this.state.audittype} closeDialog={this.closeDialog} />                   
                    </div>
                </div>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return state;
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userdetails, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataTable));


// WEBPACK FOOTER //
// ./app/auditdetails/AuditList/datatable.js